(() => {
  const root = document.querySelector('[data-pv95-station]');
  if (!root) return;

  // Mission 10A radio cleanup: the large center console is the only station radio.
  document.querySelectorAll('.pv-station-radio').forEach((node) => node.remove());

  const daily = [
    ['Sticker Bay calibration', 'Steve moved one sticker 0.04 mm. Morale remains unchanged.'],
    ['Coffee reserves critical', 'Larry has declared this an emergency. Bob has not.'],
    ['Unscheduled innovation', 'Gary said “hear me out.” The legal department disconnected.'],
    ['Maintenance success', 'Kevin repaired Dock 2 and only misplaced three tools. A station record.'],
    ['Artwork received', 'EVA-7 identified the uploaded image as “possibly a logo.”'],
    ['Command inspection', 'Bob found Larry working. Both parties were surprised.']
  ];

  const ticker = [
    'Larry has been located. This is not expected to last.',
    'Sticker Bay celebrates another perfectly unnecessary adjustment.',
    'Reminder: Gary is not authorized to improve the coffee machine.',
    'Kevin found his wrench. Kevin has now misplaced his wrench.',
    'Incoming cargo classified as: probably shirts.',
    'Commander Bob requests fewer ideas from Gary. Request denied by Gary.',
    'Earth visitor detected. Act natural.'
  ];

  // Each thread is a complete scene. The system finishes one topic before beginning another.
  // There are enough scenes and lines to keep the radio fresh for many minutes before repeating.
  const radioThreads = [
    [
      ['COMMANDER BOB', 'COMMAND', 'Larry, status report on Satellite Array Four.'],
      ['LARRY', 'SATELLITE TECH', 'Good news: it is still in space.'],
      ['COMMANDER BOB', 'COMMAND', 'That was not the question.'],
      ['LARRY', 'SATELLITE TECH', 'Then I may have prepared the wrong report.'],
      ['EVA-7', 'SYSTEMS', 'Satellite Array Four is operating at ninety-eight percent efficiency.'],
      ['COMMANDER BOB', 'COMMAND', 'Thank you, EVA. Larry, what did you repair?'],
      ['LARRY', 'SATELLITE TECH', 'The coffee holder. It had a dangerous wobble.'],
      ['COMMANDER BOB', 'COMMAND', 'Return to the array.'],
      ['LARRY', 'SATELLITE TECH', 'Copy that. Bringing the coffee holder for field testing.']
    ],
    [
      ['STEVE', 'STICKER BAY', 'Production hold. I found an alignment problem.'],
      ['KEVIN', 'MAINTENANCE', 'How bad is it?'],
      ['STEVE', 'STICKER BAY', 'The cut line is off by 0.04 millimeters.'],
      ['KEVIN', 'MAINTENANCE', 'Can a human eye see that?'],
      ['STEVE', 'STICKER BAY', 'Mine can.'],
      ['EVA-7', 'SYSTEMS', 'Independent scan confirms the offset is 0.038 millimeters.'],
      ['STEVE', 'STICKER BAY', 'I knew it was worse than it looked.'],
      ['COMMANDER BOB', 'COMMAND', 'How long is the correction?'],
      ['STEVE', 'STICKER BAY', 'Six minutes. Then forty minutes of verification.'],
      ['KEVIN', 'MAINTENANCE', 'I am going to pretend the radio cut out.']
    ],
    [
      ['KEVIN', 'MAINTENANCE', 'Has anyone seen a magnetic wrench with orange tape?'],
      ['LARRY', 'SATELLITE TECH', 'Define “seen.”'],
      ['KEVIN', 'MAINTENANCE', 'Larry.'],
      ['LARRY', 'SATELLITE TECH', 'I saw something wrench-shaped near Dock Two.'],
      ['EVA-7', 'SYSTEMS', 'Camera review shows Larry carrying the wrench at 09:14.'],
      ['LARRY', 'SATELLITE TECH', 'That footage lacks important context.'],
      ['KEVIN', 'MAINTENANCE', 'What context?'],
      ['LARRY', 'SATELLITE TECH', 'I needed to open a coffee crate.'],
      ['COMMANDER BOB', 'COMMAND', 'Return Kevin’s wrench.'],
      ['LARRY', 'SATELLITE TECH', 'Absolutely. As soon as I remember where I put the coffee crate.']
    ],
    [
      ['GARY', 'INNOVATION', 'I have completed the coffee machine upgrade.'],
      ['COMMANDER BOB', 'COMMAND', 'You were specifically told not to touch it.'],
      ['GARY', 'INNOVATION', 'Correct. That is why I used tools.'],
      ['EVA-7', 'SYSTEMS', 'Machine pressure is now three hundred percent above specification.'],
      ['LARRY', 'SATELLITE TECH', 'It made my coffee in four-tenths of a second.'],
      ['STEVE', 'STICKER BAY', 'It also moved the mug three feet to the left.'],
      ['GARY', 'INNOVATION', 'Faster coffee requires faster reflexes.'],
      ['COMMANDER BOB', 'COMMAND', 'Restore the original settings.'],
      ['GARY', 'INNOVATION', 'I did not write them down.'],
      ['COMMANDER BOB', 'COMMAND', 'Of course you did not.']
    ],
    [
      ['EVA-7', 'SYSTEMS', 'New artwork upload received.'],
      ['STEVE', 'STICKER BAY', 'Resolution?'],
      ['EVA-7', 'SYSTEMS', 'One hundred twelve by eighty-six pixels.'],
      ['STEVE', 'STICKER BAY', 'Please tell me that is the thumbnail.'],
      ['EVA-7', 'SYSTEMS', 'It is titled final-logo-FINAL-really-final-screenshot-two.'],
      ['LARRY', 'SATELLITE TECH', 'That sounds official.'],
      ['STEVE', 'STICKER BAY', 'It sounds like a cry for help.'],
      ['COMMANDER BOB', 'COMMAND', 'Can it be printed?'],
      ['EVA-7', 'SYSTEMS', 'At current quality: only on an object viewed from orbit.'],
      ['STEVE', 'STICKER BAY', 'I will contact the Earth visitor. Politely.']
    ],
    [
      ['COMMANDER BOB', 'COMMAND', 'Launch Bay, confirm cargo readiness.'],
      ['KEVIN', 'MAINTENANCE', 'Cargo is packed, sealed, and facing mostly upward.'],
      ['COMMANDER BOB', 'COMMAND', 'Mostly?'],
      ['KEVIN', 'MAINTENANCE', 'The arrows became suggestions after Gary moved the labels.'],
      ['GARY', 'INNOVATION', 'I improved their visual hierarchy.'],
      ['STEVE', 'STICKER BAY', 'You rotated every label nine degrees.'],
      ['GARY', 'INNOVATION', 'Dynamic shipping.'],
      ['COMMANDER BOB', 'COMMAND', 'Steve, correct the labels. Kevin, secure the cargo.'],
      ['LARRY', 'SATELLITE TECH', 'Should I help?'],
      ['COMMANDER BOB', 'COMMAND', 'No.'],
      ['LARRY', 'SATELLITE TECH', 'Understood. Returning to strategic observation.']
    ],
    [
      ['EVA-7', 'SYSTEMS', 'Meteor debris approaching the outer communications array.'],
      ['COMMANDER BOB', 'COMMAND', 'Larry, suit up.'],
      ['LARRY', 'SATELLITE TECH', 'Already suited.'],
      ['COMMANDER BOB', 'COMMAND', 'Then why are you in the break room?'],
      ['LARRY', 'SATELLITE TECH', 'Pre-mission hydration.'],
      ['KEVIN', 'MAINTENANCE', 'That is coffee.'],
      ['LARRY', 'SATELLITE TECH', 'Coffee contains water.'],
      ['EVA-7', 'SYSTEMS', 'Debris will pass harmlessly in forty seconds.'],
      ['LARRY', 'SATELLITE TECH', 'Excellent. My preparation worked.'],
      ['COMMANDER BOB', 'COMMAND', 'Nothing you did affected its trajectory.'],
      ['LARRY', 'SATELLITE TECH', 'That cannot be proven.']
    ],
    [
      ['STEVE', 'STICKER BAY', 'Who placed a rubber chicken on the calibration table?'],
      ['GARY', 'INNOVATION', 'That is a precision morale instrument.'],
      ['STEVE', 'STICKER BAY', 'It is touching the ruler.'],
      ['GARY', 'INNOVATION', 'It is learning.'],
      ['EVA-7', 'SYSTEMS', 'The chicken has no measurable learning capability.'],
      ['GARY', 'INNOVATION', 'Not with that attitude.'],
      ['COMMANDER BOB', 'COMMAND', 'Remove it from Sticker Bay.'],
      ['STEVE', 'STICKER BAY', 'And sanitize the ruler.'],
      ['GARY', 'INNOVATION', 'The chicken or the ruler?'],
      ['STEVE', 'STICKER BAY', 'Yes.']
    ],
    [
      ['KEVIN', 'MAINTENANCE', 'Dock Three door is making the noise again.'],
      ['COMMANDER BOB', 'COMMAND', 'Which noise?'],
      ['KEVIN', 'MAINTENANCE', 'The expensive one.'],
      ['EVA-7', 'SYSTEMS', 'Audio analysis indicates a worn guide bearing.'],
      ['KEVIN', 'MAINTENANCE', 'I was going to say that next.'],
      ['LARRY', 'SATELLITE TECH', 'I can hold the door while you fix it.'],
      ['KEVIN', 'MAINTENANCE', 'Last time you held it, you wandered away.'],
      ['LARRY', 'SATELLITE TECH', 'I remembered an important meeting.'],
      ['COMMANDER BOB', 'COMMAND', 'There was no meeting.'],
      ['LARRY', 'SATELLITE TECH', 'That explains why nobody attended.']
    ],
    [
      ['EVA-7', 'SYSTEMS', 'Coffee inventory has fallen below operational minimum.'],
      ['LARRY', 'SATELLITE TECH', 'Initiating emergency protocol.'],
      ['COMMANDER BOB', 'COMMAND', 'There is no coffee emergency protocol.'],
      ['LARRY', 'SATELLITE TECH', 'There is now.'],
      ['STEVE', 'STICKER BAY', 'Do not print emergency labels in Sticker Bay.'],
      ['LARRY', 'SATELLITE TECH', 'Too late. They are very professional.'],
      ['KEVIN', 'MAINTENANCE', 'A supply shuttle arrives in twelve minutes.'],
      ['LARRY', 'SATELLITE TECH', 'Can we meet it halfway?'],
      ['EVA-7', 'SYSTEMS', 'That is not how orbital docking works.'],
      ['LARRY', 'SATELLITE TECH', 'Not with that attitude.'],
      ['GARY', 'INNOVATION', 'I have a launcher.'],
      ['COMMANDER BOB', 'COMMAND', 'Gary, no.']
    ],
    [
      ['COMMANDER BOB', 'COMMAND', 'Crew, we have an Earth visitor on the station site.'],
      ['LARRY', 'SATELLITE TECH', 'Should we look busy?'],
      ['STEVE', 'STICKER BAY', 'Some of us are busy.'],
      ['KEVIN', 'MAINTENANCE', 'I can carry a wrench around.'],
      ['EVA-7', 'SYSTEMS', 'That would represent a forty-two percent increase in normal wrench retention.'],
      ['GARY', 'INNOVATION', 'I can demonstrate the experimental button.'],
      ['COMMANDER BOB', 'COMMAND', 'You will do no such thing.'],
      ['LARRY', 'SATELLITE TECH', 'What should I do?'],
      ['COMMANDER BOB', 'COMMAND', 'Your actual job.'],
      ['LARRY', 'SATELLITE TECH', 'I walked into that one.']
    ],
    [
      ['STEVE', 'STICKER BAY', 'Custom sticker run complete.'],
      ['COMMANDER BOB', 'COMMAND', 'Quality status?'],
      ['STEVE', 'STICKER BAY', 'Cuts are clean. Color is accurate. Alignment is acceptable.'],
      ['KEVIN', 'MAINTENANCE', 'Acceptable sounds positive.'],
      ['STEVE', 'STICKER BAY', 'It means I will only inspect them twice more.'],
      ['EVA-7', 'SYSTEMS', 'Projected completion in forty-seven minutes.'],
      ['COMMANDER BOB', 'COMMAND', 'The order ships today.'],
      ['STEVE', 'STICKER BAY', 'Then I will inspect faster.'],
      ['LARRY', 'SATELLITE TECH', 'I can help count them.'],
      ['STEVE', 'STICKER BAY', 'No.'],
      ['LARRY', 'SATELLITE TECH', 'Everyone is very protective of their departments today.']
    ]
  ];

  const dayKey = Math.floor(Date.now() / 86400000);
  const incident = daily[dayKey % daily.length];
  root.querySelector('[data-pv95-daily-title]').textContent = incident[0];
  root.querySelector('[data-pv95-daily-copy]').textContent = incident[1];

  const clock = root.querySelector('[data-pv95-clock]');
  const updateClock = () => clock.textContent = new Date().toLocaleTimeString([], {hour12:false});
  updateClock();
  setInterval(updateClock, 1000);

  let tickerIndex = dayKey % ticker.length;
  const tickerEl = root.querySelector('[data-pv95-ticker]');
  setInterval(() => {
    tickerEl.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(-8px)'}],{duration:240,fill:'forwards'}).finished.then(() => {
      tickerIndex = (tickerIndex + 1) % ticker.length;
      tickerEl.textContent = ticker[tickerIndex];
      tickerEl.animate([{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:300,fill:'forwards'});
    });
  }, 6500);

  const threadEl = root.querySelector('[data-pv95-radio-thread]');
  let threadIndex = dayKey % radioThreads.length;
  let lineIndex = 0;
  let currentThread = radioThreads[threadIndex];
  const lineDelay = 5600;
  const threadPause = 11000;

  const appendRadio = (entry, initial = false) => {
    const [name, dept, message] = entry;
    const row = document.createElement('div');
    row.className = `pv95-radio-entry pv95-radio-entry--${name.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`;
    row.innerHTML = `<div class="pv95-radio-avatar-mini" aria-hidden="true"><span>${name === 'EVA-7' ? 'E7' : name.charAt(0)}</span></div><div class="pv95-radio-copy"><small><b>${name}</b> // ${dept}</small><p>${message}</p></div><time>${new Date().toLocaleTimeString([], {hour:'2-digit',minute:'2-digit'})}</time>`;
    threadEl.appendChild(row);
    while (threadEl.children.length > 7) threadEl.firstElementChild.remove();
    requestAnimationFrame(() => {
      row.classList.add('is-visible');
      threadEl.scrollTo({top: threadEl.scrollHeight, behavior: initial ? 'auto' : 'smooth'});
    });
  };

  const queueNextLine = (delay = lineDelay) => {
    window.setTimeout(() => {
      if (lineIndex >= currentThread.length) {
        threadIndex = (threadIndex + 1) % radioThreads.length;
        currentThread = radioThreads[threadIndex];
        lineIndex = 0;
        const separator = document.createElement('div');
        separator.className = 'pv95-radio-topic-break';
        separator.textContent = 'CHANNEL PAUSE // NEW CREW THREAD INCOMING';
        threadEl.appendChild(separator);
        while (threadEl.children.length > 7) threadEl.firstElementChild.remove();
        threadEl.scrollTo({top: threadEl.scrollHeight, behavior:'smooth'});
        queueNextLine(threadPause);
        return;
      }
      appendRadio(currentThread[lineIndex]);
      lineIndex += 1;
      queueNextLine();
    }, delay);
  };

  // Load the opening portion of one coherent scene, then continue it in real time.
  currentThread.slice(0, 4).forEach((entry) => appendRadio(entry, true));
  lineIndex = 4;
  queueNextLine(5000);

  const coffee = root.querySelector('[data-pv95-coffee]');
  const coffeeLabel = root.querySelector('[data-pv95-coffee-label]');
  setInterval(() => {
    const level = 14 + Math.round(Math.random()*24);
    coffee.style.setProperty('--level', `${level}%`);
    coffeeLabel.textContent = level < 22 ? 'CRITICAL' : 'LOW';
  }, 7000);
})();
